export const articles = [
  {
    id: '1',
    code: 'SSIS-888',
    title: 'SSIS-888 新人NO.1 STYLE 奇迹般的透明感',
    category: 'latest',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20film%20poster%20style%20image%20with%20elegant%20female%20portrait%2C%20soft%20natural%20lighting%2C%20minimalist%20composition%2C%20warm%20cream%20background%2C%20professional%20photography%2C%20clean%20and%20artistic%20mood%2C%20cinematic%20tone%2C%20subtle%20elegance%2C%20editorial%20quality&width=800&height=1120&seq=fh-article-01&orientation=portrait',
    studio: 'S1 NO.1 STYLE',
    label: 'S1',
    releaseDate: '2026-07-15',
    duration: '120分钟',
    actors: ['新野莉子'],
    director: '秋山健太',
    rating: 4.8,
    views: 128500,
    description: 'S1专属新人新野莉子正式出道！拥有令人惊叹的透明感与纯粹气质，一经亮相便引发业界轰动。本作为其出道首作，全方位展现这位潜力新星的独特魅力。从初见面的紧张到逐渐绽放的自信，每一帧都值得珍藏。',
    tags: ['新人', '出道作', '透明感', '美少女'],
  },
  {
    id: '2',
    code: 'IPX-977',
    title: 'IPX-977 禁欲一个月后的极限爆发',
    category: 'hot',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Japanese%20film%20poster%20with%20intense%20emotional%20expression%2C%20soft%20warm%20lighting%2C%20minimalist%20cream%20background%2C%20cinematic%20portrait%20photography%2C%20artistic%20composition%2C%20elegant%20mood%2C%20professional%20quality%2C%20clean%20aesthetic&width=800&height=1120&seq=fh-article-02&orientation=portrait',
    studio: 'IDEA POCKET',
    label: 'IP',
    releaseDate: '2026-07-10',
    duration: '150分钟',
    actors: ['桃乃木香奈'],
    director: '松本和也',
    rating: 4.9,
    views: 235600,
    description: '人气女优桃乃木香奈挑战极限禁欲企划！整整一个月完全禁止一切，积累到极致的感情终于爆发。本作完美记录了她从禁欲期到释放的全过程，情感张力十足，堪称年度最佳表演之一。',
    tags: ['禁欲', '情感爆发', '人气系列', '演技派'],
  },
  {
    id: '3',
    code: 'MIDV-456',
    title: 'MIDV-456 绝顶开发 初体验的巅峰快感',
    category: 'featured',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20soft%20and%20elegant%20Japanese%20style%20portrait%20photography%2C%20gentle%20expression%2C%20warm%20natural%20lighting%2C%20clean%20cream%20background%2C%20minimalist%20composition%2C%20cinematic%20mood%2C%20professional%20quality%2C%20artistic%20film%20poster%20aesthetic&width=800&height=1120&seq=fh-article-03&orientation=portrait',
    studio: 'MOODYZ',
    label: 'MOODYZ',
    releaseDate: '2026-07-08',
    duration: '180分钟',
    actors: ['石川澪'],
    director: '田中裕也',
    rating: 4.7,
    views: 189200,
    description: 'MOODYZ王牌系列"绝顶开发"最新力作！石川澪挑战全新领域的快感体验，从初次羞涩到完全释放，逐步展现令人惊叹的成长。本作用细腻的镜头语言记录每一个珍贵瞬间。',
    tags: ['绝顶开发', '初体验', '成长纪录', '细腻'],
  },
  {
    id: '4',
    code: 'STARS-852',
    title: 'STARS-852 梦幻共演 两大女王的巅峰对决',
    category: 'hot',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20duo%20portrait%20in%20Japanese%20film%20poster%20style%2C%20two%20elegant%20women%2C%20sophisticated%20lighting%2C%20warm%20cream%20background%2C%20cinematic%20composition%2C%20artistic%20photography%2C%20high%20fashion%20aesthetic%2C%20clean%20and%20professional%2C%20dramatic%20presence&width=800&height=1120&seq=fh-article-04&orientation=portrait',
    studio: 'SOD Create',
    label: 'SOD',
    releaseDate: '2026-07-05',
    duration: '240分钟',
    actors: ['神木丽', '小凑四叶'],
    director: '佐藤健一',
    rating: 4.9,
    views: 312400,
    description: 'SOD年度巨献！神木丽与小凑四叶两位顶尖女优首次梦幻共演。截然不同的风格碰撞出惊人火花，超长240分钟豪华收录，每一场对手戏都是经典。两家粉丝翘首以盼的世纪合作终于实现！',
    tags: ['共演', '女王对决', '年度巨献', '豪华'],
  },
  {
    id: '5',
    code: 'ABW-299',
    title: 'ABW-299 完全主观 极上治愈系女友体验',
    category: 'featured',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20gentle%20Japanese%20portrait%20with%20soft%20smile%2C%20natural%20window%20light%2C%20cozy%20atmosphere%2C%20cream%20toned%20background%2C%20cinematic%20film%20poster%20style%2C%20minimalist%20composition%2C%20artistic%20quality%2C%20elegant%20mood&width=800&height=1120&seq=fh-article-05&orientation=portrait',
    studio: 'PRESTIGE',
    label: 'PRESTIGE',
    releaseDate: '2026-07-03',
    duration: '135分钟',
    actors: ['八挂海'],
    director: '中村翔太',
    rating: 4.6,
    views: 156800,
    description: 'PRESTIGE人气系列"完全主观"最新作！八挂海化身完美治愈系女友，全片采用主观视角拍摄，让观众身临其境感受甜蜜约会体验。从清晨的早安吻到夜晚的温情时刻，每一秒都是治愈。',
    tags: ['主观视角', '治愈系', '女友体验', '甜蜜'],
  },
  {
    id: '6',
    code: 'JUQ-378',
    title: 'JUQ-378 熟女的诱惑 极上美体的官能世界',
    category: 'classic',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mature%20and%20sophisticated%20Japanese%20portrait%20photography%2C%20elegant%20expression%2C%20warm%20lighting%2C%20cream%20background%2C%20cinematic%20composition%2C%20artistic%20film%20poster%2C%20refined%20aesthetic%2C%20professional%20quality%2C%20classic%20beauty&width=800&height=1120&seq=fh-article-06&orientation=portrait',
    studio: 'Madonna',
    label: 'Madonna',
    releaseDate: '2026-06-28',
    duration: '145分钟',
    actors: ['风间由美'],
    director: '小林正一',
    rating: 4.8,
    views: 201300,
    description: 'Madonna专属风间由美的巅峰之作！成熟女性独有的魅力与韵味在本作中展现得淋漓尽致。精湛的演技配合绝美的画面构图，每一个镜头都宛如艺术品。这是属于成熟女性的官能美学教科书。',
    tags: ['熟女', '官能美', '艺术性', '经典'],
  },
  {
    id: '7',
    code: 'FSDSS-609',
    title: 'FSDSS-609 美少女的制服初恋物语',
    category: 'new-face',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20and%20fresh%20Japanese%20portrait%20with%20school%20uniform%20aesthetic%2C%20innocent%20expression%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20cinematic%20film%20poster%20style%2C%20youthful%20and%20pure%20mood%2C%20minimalist%20composition&width=800&height=1120&seq=fh-article-07&orientation=portrait',
    studio: 'FALENO',
    label: 'FALENO',
    releaseDate: '2026-06-25',
    duration: '125分钟',
    actors: ['天使萌'],
    director: '渡边悠太',
    rating: 4.5,
    views: 143200,
    description: 'FALENO专属天使萌挑战制服青春物语！以纯美少女形象演绎青涩初恋故事，清新自然的表演让人仿佛回到学生时代。制服、樱花、教室，每一个元素都充满青春气息。',
    tags: ['制服', '青春', '初恋', '美少女'],
  },
  {
    id: '8',
    code: 'CAWD-567',
    title: 'CAWD-567 首次挑战 人生初解禁Special',
    category: 'latest',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fresh%20and%20vibrant%20Japanese%20portrait%20photography%2C%20bright%20expression%2C%20soft%20warm%20lighting%2C%20clean%20cream%20background%2C%20cinematic%20film%20poster%2C%20energetic%20mood%2C%20minimalist%20composition%2C%20professional%20quality&width=800&height=1120&seq=fh-article-08&orientation=portrait',
    studio: 'kawaii*',
    label: 'kawaii',
    releaseDate: '2026-07-01',
    duration: '160分钟',
    actors: ['伊藤舞雪'],
    director: '高桥翔',
    rating: 4.7,
    views: 178900,
    description: 'kawaii*专属伊藤舞雪挑战人生首次解禁！不断突破自我的她，这次向全新领域发起冲击。从决定挑战的忐忑到完成的喜悦，真实记录了每一步的心路历程。',
    tags: ['首次挑战', '解禁', '突破自我', '记录'],
  },
  {
    id: '9',
    code: 'DV-1705',
    title: 'DV-1705 传奇复活 传说中的女神归来',
    category: 'classic',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20classic%20and%20timeless%20Japanese%20beauty%20portrait%2C%20elegant%20and%20graceful%2C%20soft%20warm%20lighting%2C%20cream%20background%2C%20cinematic%20film%20poster%2C%20nostalgic%20mood%2C%20artistic%20quality%2C%20vintage%20aesthetic%20modern%20twist&width=800&height=1120&seq=fh-article-09&orientation=portrait',
    studio: 'ALICE JAPAN',
    label: 'ALICE',
    releaseDate: '2026-06-20',
    duration: '140分钟',
    actors: ['麻美由真'],
    director: '清水宏明',
    rating: 4.9,
    views: 289700,
    description: '传说的女神麻美由真震撼复活归来！时隔多年重回荧幕，岁月未曾削减她的光彩，反而增添了成熟韵味。本作记录了她回归的心路历程与全新作品，对于老粉丝来说是绝对不能错过的感动之作。',
    tags: ['传奇', '复活', '女神', '感动'],
  },
  {
    id: '10',
    code: 'PPPE-138',
    title: 'PPPE-138 极上巨乳 冲击性的压倒存在感',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20striking%20Japanese%20portrait%20with%20dramatic%20presence%2C%20confident%20expression%2C%20soft%20warm%20lighting%2C%20clean%20cream%20background%2C%20cinematic%20film%20poster%2C%20powerful%20composition%2C%20artistic%20quality%2C%20minimalist%20aesthetic&width=800&height=1120&seq=fh-article-10&orientation=portrait',
    studio: 'OPPAI',
    label: 'OPPAI',
    releaseDate: '2026-07-12',
    duration: '130分钟',
    actors: ['安斋拉拉'],
    director: '山田隆',
    rating: 4.8,
    views: 267400,
    description: 'OPPAI专属安斋拉拉的冲击性新作！压倒性的存在感与无与伦比的身材比例，每一次亮相都让人过目难忘。本作以电影级别的制作水准，完美呈现她的独特魅力。',
    tags: ['极上', '压倒性', '电影级', '冲击'],
  },
  {
    id: '11',
    code: 'MIDE-999',
    title: 'MIDE-999 温泉旅行 两天一夜的亲密记录',
    category: 'solo',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20relaxing%20Japanese%20onsen%20theme%20portrait%2C%20peaceful%20expression%2C%20soft%20warm%20lighting%2C%20cream%20background%2C%20cinematic%20film%20poster%2C%20serene%20mood%2C%20minimalist%20composition%2C%20professional%20quality%2C%20travel%20vibe&width=800&height=1120&seq=fh-article-11&orientation=portrait',
    studio: 'MOODYZ',
    label: 'MOODYZ',
    releaseDate: '2026-06-22',
    duration: '155分钟',
    actors: ['七泽美亚'],
    director: '佐佐木明',
    rating: 4.6,
    views: 134500,
    description: 'MOODYZ人气系列温泉旅行篇！七泽美亚带你体验两天一夜的温泉之旅。在传统日式旅馆中享受美食、泡汤、赏景，每一个瞬间都温馨惬意。旅行中的她展现出与平时不同的一面。',
    tags: ['温泉', '旅行', '和风', '温馨'],
  },
  {
    id: '12',
    code: 'EBOD-987',
    title: 'EBOD-987 完美BODY 神的造物最高杰作',
    category: 'featured',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sculptural%20Japanese%20portrait%20photography%2C%20perfect%20form%2C%20artistic%20lighting%2C%20clean%20cream%20background%2C%20cinematic%20film%20poster%2C%20elegant%20composition%2C%20minimalist%20aesthetic%2C%20professional%20quality%2C%20statuesque&width=800&height=1120&seq=fh-article-12&orientation=portrait',
    studio: 'E-BODY',
    label: 'E-BODY',
    releaseDate: '2026-07-18',
    duration: '140分钟',
    actors: ['山手梨爱'],
    director: '加藤浩',
    rating: 4.9,
    views: 345800,
    description: 'E-BODY专属山手梨爱的完美之作！被赞为"神的造物"的极致BODY，在本作中通过精湛的摄影技术与灯光设计得到完美呈现。每一个角度都如雕塑般精致，堪称视觉的极致盛宴。',
    tags: ['完美BODY', '神造物', '视觉盛宴', '最高'],
  },
];